import { useSelector } from 'react-redux'
import Header from './components/header/Header'
import BettingCard from './components/bettingpanel/BettingCard'
import GameCanvas from '@components/canvas/GameCanvas'
import LastCrashMultipliers from '@components/lastCrashMultipliers/LastCrashMultipliers'
import OverlayController from '@components/overlays/OverlayController'

/**
 * Standard MINI layout — the compact embedded skin shared by every standard
 * game (only the header icon / tagline / accent differ per game, from
 * games.js `mini`). Reuses the canvas, the classic-betting hook and the shared
 * multipliers; the per-component heights come from the same responsive
 * `dimensions` plumbing the normal layout uses (resolveStandard MINI branch).
 */
const Index = ({ game }) => {
  const { dimensions } = useSelector((state) => state.layout)
  const sizes = dimensions?.sizes
  const gap = dimensions?.gap ?? 0
  const accentColor = game?.mini?.accentColor

  const heightOf = (key) => {
    const height = sizes?.[key]?.height
    return height != null && height > 0 ? height : null
  }

  return (
    <div
      className="standard-mini-layout-outer-container"
      style={accentColor ? { '--standard-mini-accent-color': accentColor } : undefined}
    >
      <div className="standard-mini-layout-inner-container">
        <div
          className="smn-header-container"
          style={{ height: heightOf('header'), marginBottom: gap }}
        >
          <Header game={game} />
        </div>

        <div
          className="smn-canvas-container"
          style={{ height: heightOf('canvas'), marginBottom: gap }}
        >
          <GameCanvas />
        </div>

        <div
          className="smn-betcard-container"
          style={{ height: heightOf('bettingPanel'), marginBottom: gap }}
        >
          <BettingCard />
        </div>

        <div className="smn-recent-results-container" style={{ height: heightOf('lastCrashMultipliers') }}>
          <div className="smn-recent-results-label">Recent Results</div>
          <div className="smn-recent-results-list">
            <LastCrashMultipliers variant="mini" />
          </div>
        </div>
      </div>

      <OverlayController />
    </div>
  )
}

export default Index
